
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 16.75c.813 0 1.578.094 2.297.281.719.157 1.36.36 1.922.61.562.25 1 .625 1.312 1.125.313.5.469 1.03.469 1.593V22H10v-1.594c0-.593.156-1.14.469-1.64.312-.5.75-.875 1.312-1.125a9.933 9.933 0 011.922-.61A9.075 9.075 0 0116 16.75zm-8.016.234c.563 0 1.032-.187 1.407-.562.406-.406.609-.875.609-1.406 0-.563-.203-1.032-.61-1.407A1.834 1.834 0 007.985 13c-.53 0-1 .203-1.406.61-.375.374-.562.843-.562 1.406 0 .53.187 1 .562 1.406a2.01 2.01 0 001.406.562zM9.11 18.11a2.63 2.63 0 00-.515-.047 3.707 3.707 0 00-.61-.046c-.5 0-.984.047-1.453.14a7.117 7.117 0 00-1.312.422 1.898 1.898 0 00-.89.75A2.055 2.055 0 004 20.453V22h4.5v-1.594c0-.812.203-1.578.61-2.297zm14.907-1.125c.53 0 .984-.187 1.359-.562.406-.406.61-.875.61-1.406 0-.563-.204-1.032-.61-1.407-.375-.406-.828-.609-1.36-.609-.562 0-1.046.203-1.453.61-.375.374-.562.843-.562 1.406 0 .53.188 1 .563 1.406.406.375.89.562 1.453.562zM28 20.454c0-.407-.11-.782-.328-1.126a1.898 1.898 0 00-.89-.75 6.855 6.855 0 00-1.36-.422 6.708 6.708 0 00-1.406-.14c-.22 0-.422.015-.61.047-.187 0-.36.015-.515.046.406.72.609 1.485.609 2.297V22H28v-1.547zM16 10c.563 0 1.063.14 1.5.422.469.25.828.61 1.078 1.078.281.438.422.938.422 1.5a2.95 2.95 0 01-.422 1.547 2.97 2.97 0 01-1.078 1.078c-.438.25-.938.375-1.5.375a3.235 3.235 0 01-1.547-.375 3.547 3.547 0 01-1.078-1.078A3.235 3.235 0 0113 13c0-.563.125-1.063.375-1.5a2.97 2.97 0 011.078-1.078A2.95 2.95 0 0116 10z"}})])
          )
        }
      }
    